import { render, staticRenderFns } from "./DashboardMXNCashPaymentsList.vue?vue&type=template&id=655b1d31&"
import script from "./DashboardMXNCashPaymentsList.vue?vue&type=script&lang=js&"
export * from "./DashboardMXNCashPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports